import { makeCRUDSlice } from 'redux/crudCreator';
import { brandsActions, MODEL_NAME } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, brandsActions);

export default slice.reducer;
